import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import { TIME } from '../constants/constants';

interface FormatDateProps {
  timestamp: number;
  reference?: number;
}

const calculateRelativeTime = ({
  relative,
  reference
}: {
  relative: number;
  reference: number;
}): {
  count: number;
  unit: string;
} => {
  const difference = relative - reference;
  const absoluteDifference = Math.abs(difference);

  let unit: string;
  let divisor: number;

  switch (true) {
    case absoluteDifference >= TIME.YEAR:
      unit = 'year';
      divisor = TIME.YEAR;
      break;
    case absoluteDifference >= TIME.MONTH:
      unit = 'month';
      divisor = TIME.MONTH;
      break;
    case absoluteDifference >= TIME.WEEK:
      unit = 'week';
      divisor = TIME.WEEK;
      break;
    case absoluteDifference >= TIME.DAY:
      unit = 'day';
      divisor = TIME.DAY;
      break;
    case absoluteDifference >= TIME.HOUR:
      unit = 'hour';
      divisor = TIME.HOUR;
      break;
    default:
      unit = 'minute';
      divisor = TIME.MINUTE;
      break;
  }

  return {
    count: Math.trunc(difference / divisor),
    unit
  };
};

const useDateFormatter = ({ timestamp, reference }: FormatDateProps) => {
  const { formatRelativeTime } = useIntl();
  const locale = useSelector(select.locale.get);

  if (!reference) {
    return new Date(timestamp).toLocaleDateString(locale, {
      month: 'short',
      day: '2-digit',
      year: 'numeric'
    });
  }

  const { count, unit } = calculateRelativeTime({
    relative: timestamp,
    reference
  });

  return formatRelativeTime(count, unit as Intl.RelativeTimeFormatUnit);
};

export default useDateFormatter;
